module.exports = __webpack_public_path__ + "assets/img/nx-01.bbd0afab.jpg";